import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { ThemeProvider } from 'react-css-themr'

import theme from 'globalcss/theme'

const ThemeComponent = ({ children }) => (
  <ThemeProvider theme={theme}>
    { children }
  </ThemeProvider>
)

export default ThemeComponent
